import Box from "pages/_components/Box";
import Image from "pages/_components/Image";
import Text from "pages/_components/Text";
import { arrayOf, shape, string } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { selectors } from "reducers/administration/common/administrationTicket";

const userStatusToAction = { blocked: "block", active: "unblock", delete: "delete" };

class UserActionTicket extends Component {
    static propTypes = {
        transactionData: shape({
            data: shape({
                userNameList: arrayOf(string),
                newStatus: string,
            }),
        }).isRequired,
    };

    render() {
        const { transactionData } = this.props;

        if (transactionData.data.userNameList) {
            const userAction = transactionData.data.newStatus || "delete";
            const textKey = `administration.users.action.confirmation.${userStatusToAction[userAction]}`;
            const ticketText = transactionData.data.userNameList.map((userName, index) => (
                <Box
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    display="flex"
                    background="grey"
                    borderRadius="md"
                    className="py-2 px-3"
                    fitWidth
                    gap="2">
                    <Box display="flex">
                        <Image src="images/icons/userIcon.svg" color="text" />
                    </Box>
                    <Text>{userName}</Text>
                </Box>
            ));

            return (
                <Box className="mt-7">
                    <Text component="h4" color="primary" size="body" bold labelKey={textKey} />
                    <Box display="flex" alignY="center" gap="3" wrap>
                        {ticketText}
                    </Box>
                </Box>
            );
        }
        return null;
    }
}

const mapStateToProps = (state) => ({
    transactionData: selectors.getData(state),
});
export default connect(mapStateToProps)(UserActionTicket);
